'use strict';

var $ = require('jquery');
var moduleRegistry = require('./modules/');

moduleRegistry.init();



/** WEBPACK FOOTER **
 ** ./app/scripts/app.js
 **/